import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Button, Grid, Image} from 'semantic-ui-react';
import AuthHeader from './auth-header';

function Header(props) {
  return (
    <header>
      <Grid>
        <Grid.Column width={1}>
          <Button
            icon='bars'
            color='black'
            onClick={function (event) {
              event.stopPropagation();
              props.setVisible(visible => !visible);
            }}
          />
        </Grid.Column>
        <Grid.Column width={5} only='tablet computer' className='text-center'>
          <Link to='/'>
            <Image
              height={36}
              verticalAlign='middle'
              src='https://medmoshaver.com/icons/icon-horizontal.png'
            />
          </Link>
        </Grid.Column>
        <Grid.Column mobile={14} tablet={10} computer={10} floated='right'>
          <Button.Group floated='right'>
            <AuthHeader/>
          </Button.Group>
        </Grid.Column>
      </Grid>
    </header>
  );
}

Header.propTypes = {
  setVisible: PropTypes.func.isRequired
};


export default Header;
